import AdaptiveImage from "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/heat-glow-3-color-1.png",
    width: 312,
    height: 312
});